// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================================================
   Exercise Feedback – Player View (Modern Chat-Centric Design)
   ================================================================ */

.fbp-page {
    max-width: 800px;
    margin: 0 auto;
    padding: 8px 12px 0;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 60px);
    overflow: hidden;
}

/* ── Compact Exercise Info Bar ──────────────────────── */
.fbp-exercise-bar {
    display: flex;
    align-items: center;
    gap: 14px;
    background: #fff;
    border-radius: 14px;
    padding: 12px 16px;
    box-shadow: 0 1px 8px rgba(8, 119, 188, 0.08);
    margin-bottom: 8px;
    flex-shrink: 0;
}

.fbp-exercise-bar__icon {
    width: 44px;
    height: 44px;
    border-radius: 12px;
    background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 22px;
    color: var(--brand-primary);
}

.fbp-exercise-bar__info {
    flex: 1 1;
    min-width: 0;
}

.fbp-exercise-bar__name {
    font-size: 15px;
    font-weight: 700;
    color: #1a2b3c;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.fbp-exercise-bar__meta {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 3px;
    flex-wrap: wrap;
}

.fbp-exercise-bar__tag {
    font-size: 11px;
    font-weight: 600;
    color: var(--brand-primary);
    background: rgba(var(--brand-primary-rgb), 0.08);
    padding: 2px 8px;
    border-radius: 6px;
    white-space: nowrap;
}

.fbp-exercise-bar__detail {
    font-size: 11px;
    color: #78909c;
    display: flex;
    align-items: center;
    gap: 3px;
}

/* ── Auto-evaluation Section ───────────────────────── */
.fbp-eval-section {
    background: #fff;
    border-radius: 14px;
    padding: 14px 16px;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
    margin-bottom: 8px;
    flex-shrink: 0;
}

.fbp-eval-section__title {
    font-size: 13px;
    font-weight: 700;
    color: #37474f;
    margin: 0 0 10px;
}

.fbp-eval-row {
    display: flex;
    gap: 6px;
    justify-content: space-between;
    margin-bottom: 10px;
}

.fbp-eval-row:last-child {
    margin-bottom: 0;
}

.fbp-eval-option {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3px;
    padding: 8px 4px;
    border-radius: 12px;
    cursor: pointer;
    border: 2px solid transparent;
    background: #f8fafb;
    transition: all 0.2s ease;
    -webkit-user-select: none;
            user-select: none;
}

.fbp-eval-option:hover {
    background: #e3f2fd;
}

.fbp-eval-option--selected {
    border-color: var(--brand-primary);
    background: rgba(var(--brand-primary-rgb), 0.06);
}

.fbp-eval-option__emoji {
    font-size: 28px;
    line-height: 1;
}

.fbp-eval-option__label {
    font-size: 9px;
    font-weight: 600;
    color: #78909c;
    text-align: center;
    line-height: 1.2;
}

.fbp-eval-option--selected .fbp-eval-option__label {
    color: var(--brand-primary);
    font-weight: 700;
}

.fbp-eval-error {
    color: #e53935;
    font-size: 12px;
    margin: 6px 0 0;
    text-align: center;
}

.fbp-eval-submit {
    width: 100%;
    padding: 10px;
    border: none;
    border-radius: 10px;
    background: var(--brand-primary);
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    font-family: var(--brand-font);
    cursor: pointer;
    margin-top: 10px;
    transition: background 0.2s;
}

.fbp-eval-submit:hover {
    background: var(--brand-primary-dark);
}

/* ── Evaluation Summary (read-only, after submitting) ── */
.fbp-eval-summary {
    display: flex;
    gap: 8px;
    padding: 0 0 8px;
    flex-shrink: 0;
}

.fbp-eval-summary-card {
    flex: 1 1;
    display: flex;
    align-items: center;
    gap: 10px;
    background: #fff;
    border-radius: 12px;
    padding: 10px 14px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.fbp-eval-summary-card__emoji {
    font-size: 28px;
    flex-shrink: 0;
    line-height: 1;
}

.fbp-eval-summary-card__content {
    min-width: 0;
}

.fbp-eval-summary-card__label {
    font-size: 10px;
    font-weight: 700;
    color: #90a4ae;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin: 0;
}

.fbp-eval-summary-card__value {
    font-size: 13px;
    font-weight: 600;
    color: #37474f;
    margin: 0;
}

/* ── Notes ─────────────────────────────────────────── */
.fbp-notes {
    background: #fff;
    border-radius: 14px;
    padding: 12px 16px;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
    margin-bottom: 8px;
    flex-shrink: 0;
}

.fbp-notes__title {
    font-size: 13px;
    font-weight: 700;
    color: var(--brand-primary);
    margin: 0 0 6px;
}

.fbp-notes__textarea {
    width: 100%;
    min-height: 44px;
    border: none;
    outline: none;
    font-size: 13px;
    font-family: var(--brand-font);
    color: #37474f;
    background: transparent;
    resize: vertical;
    line-height: 1.5;
}

.fbp-notes__textarea::placeholder {
    color: #b0bec5;
}

/* ── Chat Messages Area ────────────────────────────── */
.fbp-chat {
    flex: 1 1;
    overflow-y: auto;
    padding: 6px 0 10px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    scroll-behavior: smooth;
    min-height: 0;
}

.fbp-chat::-webkit-scrollbar {
    width: 4px;
}

.fbp-chat::-webkit-scrollbar-thumb {
    background: #cfd8dc;
    border-radius: 4px;
}

.fbp-chat__empty {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: #b0bec5;
    padding: 40px 20px;
    text-align: center;
}

.fbp-chat__empty-icon {
    font-size: 40px;
    opacity: 0.5;
}

.fbp-chat__empty-text {
    font-size: 14px;
    font-weight: 500;
}

/* ── Message Bubble ────────────────────────────────── */
.fbp-msg {
    display: flex;
    align-items: flex-end;
    gap: 8px;
    max-width: 80%;
    animation: fbpMsgIn 0.25s ease;
}

@keyframes fbpMsgIn {
    from {
        opacity: 0;
        transform: translateY(8px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.fbp-msg--mine {
    align-self: flex-end;
    flex-direction: row-reverse;
}

.fbp-msg--theirs {
    align-self: flex-start;
}

.fbp-msg__avatar {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    background: #e3f2fd;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    color: var(--brand-primary);
}

.fbp-msg__avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.fbp-msg__bubble {
    padding: 10px 14px;
    border-radius: 16px;
    font-size: 14px;
    line-height: 1.45;
    word-break: break-word;
}

.fbp-msg--mine .fbp-msg__bubble {
    background: var(--brand-primary);
    color: #fff;
    border-bottom-right-radius: 4px;
}

.fbp-msg--theirs .fbp-msg__bubble {
    background: #fff;
    color: #1a2b3c;
    border-bottom-left-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.fbp-msg__audio {
    min-width: 200px;
}

.fbp-msg__audio audio {
    width: 100%;
    height: 36px;
    border-radius: 18px;
}

.fbp-msg__video video {
    max-width: 260px;
    max-height: 200px;
    border-radius: 12px;
    display: block;
}

.fbp-chat__group-label {
    align-self: stretch;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    flex-wrap: wrap;
    padding: 10px 4px 6px;
    margin: 6px 0 2px;
}

.fbp-chat__group-label__text {
    font-size: 11px;
    font-weight: 600;
    color: #90a4ae;
    text-align: center;
}

.fbp-chat__group-label__order {
    font-weight: 500;
    color: #b0bec5;
}

.fbp-chat__group-label__badge {
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: var(--brand-primary);
    background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);
    padding: 3px 8px;
    border-radius: 999px;
}

.fbp-chat__group-label--current .fbp-chat__group-label__text {
    color: var(--brand-primary);
}

.fbp-msg--current-ex.fbp-msg--theirs .fbp-msg__bubble {
    box-shadow: 0 0 0 2px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);
    background: #f3f9ff;
}

.fbp-msg--current-ex.fbp-msg--mine .fbp-msg__bubble {
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.55);
}

/* ── Composer (Input Area) ─────────────────────────── */
.fbp-composer {
    flex-shrink: 0;
    background: #fff;
    border-radius: 16px 16px 0 0;
    padding: 10px 12px;
    box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.04);
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0 -12px;
    padding-left: 16px;
    padding-right: 16px;
}

.fbp-composer__input {
    flex: 1 1;
    border: none;
    outline: none;
    font-size: 14px;
    font-family: var(--brand-font);
    padding: 10px 14px;
    border-radius: 24px;
    background: #f4f6f8;
    color: #1a2b3c;
    transition: background 0.2s;
}

.fbp-composer__input::placeholder {
    color: #b0bec5;
}

.fbp-composer__input:focus {
    background: #eceff1;
}

.fbp-composer__actions {
    display: flex;
    align-items: center;
    gap: 4px;
}

.fbp-composer__btn {
    width: 40px;
    height: 40px;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    background: transparent;
    color: #78909c;
    font-size: 20px;
}

.fbp-composer__btn:hover {
    background: #f0f4f8;
    color: var(--brand-primary);
}

.fbp-composer__btn--send {
    background: var(--brand-primary);
    color: #fff;
    width: 42px;
    height: 42px;
}

.fbp-composer__btn--send:hover {
    background: var(--brand-primary-dark);
    color: #fff;
}

.fbp-composer__btn--send svg {
    font-size: 18px;
}

.fbp-composer__video-label {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    background: transparent;
    color: #78909c;
    font-size: 18px;
}

.fbp-composer__video-label:hover {
    background: #f0f4f8;
    color: var(--brand-primary);
}

/* AudioRecorder overrides */
.fbp-composer .audio-recorder {
    background: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
    height: 40px !important;
}

.fbp-composer .audio-recorder-mic {
    color: #78909c !important;
    transition: color 0.2s !important;
}

.fbp-composer .audio-recorder-mic:hover {
    color: var(--brand-primary) !important;
}

/* ── Responsive ────────────────────────────────────── */
@media (max-width: 480px) {
    .fbp-page {
        padding: 6px 6px 0;
    }

    .fbp-exercise-bar {
        padding: 10px 12px;
        gap: 10px;
    }

    .fbp-exercise-bar__name {
        font-size: 14px;
    }

    .fbp-exercise-bar__icon {
        width: 38px;
        height: 38px;
        font-size: 18px;
    }

    .fbp-msg {
        max-width: 88%;
    }

    .fbp-eval-summary {
        flex-direction: column;
        gap: 6px;
    }

    .fbp-eval-option__emoji {
        font-size: 22px;
    }

    .fbp-eval-option {
        padding: 6px 2px;
    }

    .fbp-composer {
        margin: 0 -6px;
        padding-left: 10px;
        padding-right: 10px;
    }
}

/* ── Pinned Evaluation Video Card ── */
.fbp-pinned-video-card {
    background: #fff;
    border-radius: 14px;
    padding: 12px 16px;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
    margin-bottom: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex-shrink: 0;
}

.fbp-pinned-video-title {
    font-size: 13px;
    font-weight: 700;
    color: var(--brand-primary);
    margin: 0;
}

.fbp-pinned-video-player-container {
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 9;
    border-radius: 8px;
    overflow: hidden;
    background: #000;
    border: 1px solid rgba(120, 144, 156, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: inset 0 0 16px rgba(0, 0, 0, 0.5);
}

.fbp-pinned-video-player {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Player/ExerciseAutoevolution.css"],"names":[],"mappings":"AAAA;;qEAEqE;;AAErE;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA,0DAA0D;AAC1D;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,6CAA6C;IAC7C,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,6DAA6D;IAC7D,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,gDAAgD;IAChD,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,yDAAyD;AACzD;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;IACnB,yBAAyB;IACzB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,gDAAgD;AACpD;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,gCAAgC;IAChC,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,qCAAqC;AACzC;;AAEA,2DAA2D;AAC3D;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA,yDAAyD;AACzD;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,cAAc;IACd,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA,yDAAyD;AACzD;IACI,SAAO;IACP,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA,yDAAyD;AACzD;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,cAAc;IACd,8BAA8B;AAClC;;AAEA;IACI;QACI,UAAU;QACV,0BAA0B;IAC9B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,8BAA8B;IAC9B,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,2BAA2B;IAC3B,6DAA6D;IAC7D,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,uEAAuE;IACvE,mBAAmB;AACvB;;AAEA;IACI,+CAA+C;AACnD;;AAEA,yDAAyD;AACzD;IACI,cAAc;IACd,gBAAgB;IAChB,4BAA4B;IAC5B,kBAAkB;IAClB,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,uBAAuB;IACvB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;IAChC,WAAW;IACX,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,uBAAuB;IACvB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA,4BAA4B;AAC5B;IACI,kCAAkC;IAClC,2BAA2B;IAC3B,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA,yDAAyD;AACzD;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA,uCAAuC;AACvC;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":["/* ================================================================\n   Exercise Feedback – Player View (Modern Chat-Centric Design)\n   ================================================================ */\n\n.fbp-page {\n    max-width: 800px;\n    margin: 0 auto;\n    padding: 8px 12px 0;\n    display: flex;\n    flex-direction: column;\n    height: calc(100vh - 60px);\n    overflow: hidden;\n}\n\n/* ── Compact Exercise Info Bar ──────────────────────── */\n.fbp-exercise-bar {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    background: #fff;\n    border-radius: 14px;\n    padding: 12px 16px;\n    box-shadow: 0 1px 8px rgba(8, 119, 188, 0.08);\n    margin-bottom: 8px;\n    flex-shrink: 0;\n}\n\n.fbp-exercise-bar__icon {\n    width: 44px;\n    height: 44px;\n    border-radius: 12px;\n    background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    font-size: 22px;\n    color: var(--brand-primary);\n}\n\n.fbp-exercise-bar__info {\n    flex: 1;\n    min-width: 0;\n}\n\n.fbp-exercise-bar__name {\n    font-size: 15px;\n    font-weight: 700;\n    color: #1a2b3c;\n    margin: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.fbp-exercise-bar__meta {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin-top: 3px;\n    flex-wrap: wrap;\n}\n\n.fbp-exercise-bar__tag {\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--brand-primary);\n    background: rgba(var(--brand-primary-rgb), 0.08);\n    padding: 2px 8px;\n    border-radius: 6px;\n    white-space: nowrap;\n}\n\n.fbp-exercise-bar__detail {\n    font-size: 11px;\n    color: #78909c;\n    display: flex;\n    align-items: center;\n    gap: 3px;\n}\n\n/* ── Auto-evaluation Section ───────────────────────── */\n.fbp-eval-section {\n    background: #fff;\n    border-radius: 14px;\n    padding: 14px 16px;\n    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);\n    margin-bottom: 8px;\n    flex-shrink: 0;\n}\n\n.fbp-eval-section__title {\n    font-size: 13px;\n    font-weight: 700;\n    color: #37474f;\n    margin: 0 0 10px;\n}\n\n.fbp-eval-row {\n    display: flex;\n    gap: 6px;\n    justify-content: space-between;\n    margin-bottom: 10px;\n}\n\n.fbp-eval-row:last-child {\n    margin-bottom: 0;\n}\n\n.fbp-eval-option {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 3px;\n    padding: 8px 4px;\n    border-radius: 12px;\n    cursor: pointer;\n    border: 2px solid transparent;\n    background: #f8fafb;\n    transition: all 0.2s ease;\n    user-select: none;\n}\n\n.fbp-eval-option:hover {\n    background: #e3f2fd;\n}\n\n.fbp-eval-option--selected {\n    border-color: var(--brand-primary);\n    background: rgba(var(--brand-primary-rgb), 0.06);\n}\n\n.fbp-eval-option__emoji {\n    font-size: 28px;\n    line-height: 1;\n}\n\n.fbp-eval-option__label {\n    font-size: 9px;\n    font-weight: 600;\n    color: #78909c;\n    text-align: center;\n    line-height: 1.2;\n}\n\n.fbp-eval-option--selected .fbp-eval-option__label {\n    color: var(--brand-primary);\n    font-weight: 700;\n}\n\n.fbp-eval-error {\n    color: #e53935;\n    font-size: 12px;\n    margin: 6px 0 0;\n    text-align: center;\n}\n\n.fbp-eval-submit {\n    width: 100%;\n    padding: 10px;\n    border: none;\n    border-radius: 10px;\n    background: var(--brand-primary);\n    color: #fff;\n    font-size: 14px;\n    font-weight: 600;\n    font-family: var(--brand-font);\n    cursor: pointer;\n    margin-top: 10px;\n    transition: background 0.2s;\n}\n\n.fbp-eval-submit:hover {\n    background: var(--brand-primary-dark);\n}\n\n/* ── Evaluation Summary (read-only, after submitting) ── */\n.fbp-eval-summary {\n    display: flex;\n    gap: 8px;\n    padding: 0 0 8px;\n    flex-shrink: 0;\n}\n\n.fbp-eval-summary-card {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    background: #fff;\n    border-radius: 12px;\n    padding: 10px 14px;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);\n}\n\n.fbp-eval-summary-card__emoji {\n    font-size: 28px;\n    flex-shrink: 0;\n    line-height: 1;\n}\n\n.fbp-eval-summary-card__content {\n    min-width: 0;\n}\n\n.fbp-eval-summary-card__label {\n    font-size: 10px;\n    font-weight: 700;\n    color: #90a4ae;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin: 0;\n}\n\n.fbp-eval-summary-card__value {\n    font-size: 13px;\n    font-weight: 600;\n    color: #37474f;\n    margin: 0;\n}\n\n/* ── Notes ─────────────────────────────────────────── */\n.fbp-notes {\n    background: #fff;\n    border-radius: 14px;\n    padding: 12px 16px;\n    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);\n    margin-bottom: 8px;\n    flex-shrink: 0;\n}\n\n.fbp-notes__title {\n    font-size: 13px;\n    font-weight: 700;\n    color: var(--brand-primary);\n    margin: 0 0 6px;\n}\n\n.fbp-notes__textarea {\n    width: 100%;\n    min-height: 44px;\n    border: none;\n    outline: none;\n    font-size: 13px;\n    font-family: var(--brand-font);\n    color: #37474f;\n    background: transparent;\n    resize: vertical;\n    line-height: 1.5;\n}\n\n.fbp-notes__textarea::placeholder {\n    color: #b0bec5;\n}\n\n/* ── Chat Messages Area ────────────────────────────── */\n.fbp-chat {\n    flex: 1;\n    overflow-y: auto;\n    padding: 6px 0 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    scroll-behavior: smooth;\n    min-height: 0;\n}\n\n.fbp-chat::-webkit-scrollbar {\n    width: 4px;\n}\n\n.fbp-chat::-webkit-scrollbar-thumb {\n    background: #cfd8dc;\n    border-radius: 4px;\n}\n\n.fbp-chat__empty {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    color: #b0bec5;\n    padding: 40px 20px;\n    text-align: center;\n}\n\n.fbp-chat__empty-icon {\n    font-size: 40px;\n    opacity: 0.5;\n}\n\n.fbp-chat__empty-text {\n    font-size: 14px;\n    font-weight: 500;\n}\n\n/* ── Message Bubble ────────────────────────────────── */\n.fbp-msg {\n    display: flex;\n    align-items: flex-end;\n    gap: 8px;\n    max-width: 80%;\n    animation: fbpMsgIn 0.25s ease;\n}\n\n@keyframes fbpMsgIn {\n    from {\n        opacity: 0;\n        transform: translateY(8px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.fbp-msg--mine {\n    align-self: flex-end;\n    flex-direction: row-reverse;\n}\n\n.fbp-msg--theirs {\n    align-self: flex-start;\n}\n\n.fbp-msg__avatar {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    overflow: hidden;\n    flex-shrink: 0;\n    background: #e3f2fd;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 13px;\n    font-weight: 700;\n    color: var(--brand-primary);\n}\n\n.fbp-msg__avatar img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.fbp-msg__bubble {\n    padding: 10px 14px;\n    border-radius: 16px;\n    font-size: 14px;\n    line-height: 1.45;\n    word-break: break-word;\n}\n\n.fbp-msg--mine .fbp-msg__bubble {\n    background: var(--brand-primary);\n    color: #fff;\n    border-bottom-right-radius: 4px;\n}\n\n.fbp-msg--theirs .fbp-msg__bubble {\n    background: #fff;\n    color: #1a2b3c;\n    border-bottom-left-radius: 4px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.fbp-msg__audio {\n    min-width: 200px;\n}\n\n.fbp-msg__audio audio {\n    width: 100%;\n    height: 36px;\n    border-radius: 18px;\n}\n\n.fbp-msg__video video {\n    max-width: 260px;\n    max-height: 200px;\n    border-radius: 12px;\n    display: block;\n}\n\n.fbp-chat__group-label {\n    align-self: stretch;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    flex-wrap: wrap;\n    padding: 10px 4px 6px;\n    margin: 6px 0 2px;\n}\n\n.fbp-chat__group-label__text {\n    font-size: 11px;\n    font-weight: 600;\n    color: #90a4ae;\n    text-align: center;\n}\n\n.fbp-chat__group-label__order {\n    font-weight: 500;\n    color: #b0bec5;\n}\n\n.fbp-chat__group-label__badge {\n    font-size: 10px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n    color: var(--brand-primary);\n    background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);\n    padding: 3px 8px;\n    border-radius: 999px;\n}\n\n.fbp-chat__group-label--current .fbp-chat__group-label__text {\n    color: var(--brand-primary);\n}\n\n.fbp-msg--current-ex.fbp-msg--theirs .fbp-msg__bubble {\n    box-shadow: 0 0 0 2px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);\n    background: #f3f9ff;\n}\n\n.fbp-msg--current-ex.fbp-msg--mine .fbp-msg__bubble {\n    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.55);\n}\n\n/* ── Composer (Input Area) ─────────────────────────── */\n.fbp-composer {\n    flex-shrink: 0;\n    background: #fff;\n    border-radius: 16px 16px 0 0;\n    padding: 10px 12px;\n    box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.04);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin: 0 -12px;\n    padding-left: 16px;\n    padding-right: 16px;\n}\n\n.fbp-composer__input {\n    flex: 1;\n    border: none;\n    outline: none;\n    font-size: 14px;\n    font-family: var(--brand-font);\n    padding: 10px 14px;\n    border-radius: 24px;\n    background: #f4f6f8;\n    color: #1a2b3c;\n    transition: background 0.2s;\n}\n\n.fbp-composer__input::placeholder {\n    color: #b0bec5;\n}\n\n.fbp-composer__input:focus {\n    background: #eceff1;\n}\n\n.fbp-composer__actions {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.fbp-composer__btn {\n    width: 40px;\n    height: 40px;\n    border: none;\n    border-radius: 50%;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    background: transparent;\n    color: #78909c;\n    font-size: 20px;\n}\n\n.fbp-composer__btn:hover {\n    background: #f0f4f8;\n    color: var(--brand-primary);\n}\n\n.fbp-composer__btn--send {\n    background: var(--brand-primary);\n    color: #fff;\n    width: 42px;\n    height: 42px;\n}\n\n.fbp-composer__btn--send:hover {\n    background: var(--brand-primary-dark);\n    color: #fff;\n}\n\n.fbp-composer__btn--send svg {\n    font-size: 18px;\n}\n\n.fbp-composer__video-label {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    background: transparent;\n    color: #78909c;\n    font-size: 18px;\n}\n\n.fbp-composer__video-label:hover {\n    background: #f0f4f8;\n    color: var(--brand-primary);\n}\n\n/* AudioRecorder overrides */\n.fbp-composer .audio-recorder {\n    background: transparent !important;\n    box-shadow: none !important;\n    padding: 0 !important;\n    height: 40px !important;\n}\n\n.fbp-composer .audio-recorder-mic {\n    color: #78909c !important;\n    transition: color 0.2s !important;\n}\n\n.fbp-composer .audio-recorder-mic:hover {\n    color: var(--brand-primary) !important;\n}\n\n/* ── Responsive ────────────────────────────────────── */\n@media (max-width: 480px) {\n    .fbp-page {\n        padding: 6px 6px 0;\n    }\n\n    .fbp-exercise-bar {\n        padding: 10px 12px;\n        gap: 10px;\n    }\n\n    .fbp-exercise-bar__name {\n        font-size: 14px;\n    }\n\n    .fbp-exercise-bar__icon {\n        width: 38px;\n        height: 38px;\n        font-size: 18px;\n    }\n\n    .fbp-msg {\n        max-width: 88%;\n    }\n\n    .fbp-eval-summary {\n        flex-direction: column;\n        gap: 6px;\n    }\n\n    .fbp-eval-option__emoji {\n        font-size: 22px;\n    }\n\n    .fbp-eval-option {\n        padding: 6px 2px;\n    }\n\n    .fbp-composer {\n        margin: 0 -6px;\n        padding-left: 10px;\n        padding-right: 10px;\n    }\n}\n\n/* ── Pinned Evaluation Video Card ── */\n.fbp-pinned-video-card {\n    background: #fff;\n    border-radius: 14px;\n    padding: 12px 16px;\n    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);\n    margin-bottom: 8px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    flex-shrink: 0;\n}\n\n.fbp-pinned-video-title {\n    font-size: 13px;\n    font-weight: 700;\n    color: var(--brand-primary);\n    margin: 0;\n}\n\n.fbp-pinned-video-player-container {\n    position: relative;\n    width: 100%;\n    aspect-ratio: 16 / 9;\n    border-radius: 8px;\n    overflow: hidden;\n    background: #000;\n    border: 1px solid rgba(120, 144, 156, 0.15);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: inset 0 0 16px rgba(0, 0, 0, 0.5);\n}\n\n.fbp-pinned-video-player {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
